import React from 'react';
import { Box, TableBody, TableRow, TableCell } from '@mui/material';
import CustomSpinner from 'components/shared/CustomSpinner';

const styles: React.CSSProperties = {
  display: 'flex',
  position: 'absolute',
  top: '40%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
};

interface Props {
  center?: boolean;
}

const TableBodySpinner = ({ center = true }: Props) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell
          style={{
            border: 'none',
            color: 'inherit',
          }}
        >
          <Box style={center ? styles : undefined}>
            <CustomSpinner />
          </Box>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default TableBodySpinner;
